// Copyright 2025. WebPros International GmbH. All rights reserved.

import SettingsTab from 'common/components/ServerTabs/SettingsTab/SettingsTab';
import { connect } from 'react-redux';
import { RootState } from 'client/core/store';

const mapStateToProps = (state: RootState) => ({
    server: state.project.servers.item,
    isAdminSettings: false,
});

export default connect(mapStateToProps)(SettingsTab);
